import { Media, Texts, Title, Button } from "../Object";
import { Scroll } from "../Animation";
import { Space } from "../Layout";
import { Link } from "react-router-dom";

const Merit = () => {
  const args = {
    slug: "merit",
    length: 3,
    addText: [
      [
        "社内環境の活性化",
        "目標をしっかりと持った若い実習生が貴社に加わることで、社内に活気が出てきます。<br>仕事をする上で、学ぶ姿勢や、異国で頑張る実習生を見て刺激を受ける社員さんも多いでしょう。<br></br>外国人実習生は、日本で働き優れた技能を習得する向上心が高いため、労働意欲と目的意識の高い人材を採用することが可能となります。",
      ],
      [
        "人材確保と雇用の安定が図れる",
        "求人を出しても応募がなかったり、採用してもすぐに辞めてしまったりとお悩みの企業様も多いかと思います。技能実習生制度を利用すると技能実習は転職がないので3年、もしくは5年と定められた期間で雇用する事が可能です。その為、計画的に人手不足による人材確保と雇用の安定が図れます。",
      ],
      [
        "国際貢献とグローバル化",
        "外国の優秀な若者に技術や技能を伝えることで、貴社の社会的・国際的貢献度が高まります。<br>また、技能実習生と働くことでさまざまな交流が生まれ、日本人従業員の国際的な視野も広がり異国の文化・慣習といった新しい価値観を社内に取り入れることができます。",
      ],
    ],
  };
  return (
    <>
      <div className="p-box__wrap--gray" data-state="top-bottom">
        <Space size={['120px', '80px']} />
        <div className="l-row">
          <Space size={['0 0 80px', '0 0 64px']}>
            <Title slug="merit" type="center" />
          </Space>
        </div>

          <List {...args} />

          <Space size={['120px 0 0', '80px 0 0']}>
            <NavList />
          </Space>

        <Space size={['120px', '80px']} />
      </div>
    </>
  );
};

// Bottom List
export const NavList = (props) => {
  const args = {
    slug: props.slug ?? "bottom-nav",
    length: props.slug ?? 4,
    addText: [
      '事業内容',
      '受け入れまでの流れ ',
      'Q&A',
      '組合概要'
    ],
    link: [
      '/service/',
      '/flow/',
      '/flow/#qa',
      '/company/',
    ]
  };

  const Item = (props) => {
    return (
      <>
        <Button class="c-button--none" link={args.link[props.index]} linkType={args.link[props.index] === '/flow/#qa' ? 'hash' : ''}>
          <li className="c-grid__items--nav">
            <Media
              class="p-img__nav"
              src={`${args.slug}/list${props.index}`}
              alt="media"
            />
            <div className="c-grid__items--nav__text">
              <Texts
                slug={`${args.slug}/text${props.index}`}
                class="c-text--med"
                addText={args.addText[props.index]}
              />
            </div>
          </li>
        </Button>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i} />);
  }

  return (
    <>
      <div className="l-row" data-state="right">
        <div className="p-box__wrap--gray p-box__wrap--gray--type2">
          <Space size={["120px", "80px"]} />
          <div className="l-row l-row--normal">
            <ul className="c-grid__list--nav">{items}</ul>
          </div>
          <Space size={["120px", "80px"]} />
        </div>
      </div>
    </>
  );
};

// Main List
export const List = (props) => {
  const args = {
    slug: props.slug ?? "merit",
    length: props.length ?? 3,
    addText: props.addText,
  };

  const Item = (props) => {
    // 奇数、複数　要素の位置関係を決める変数
    const state = props.index % 2 == 0 ? "right" : "left";
    return (
      <>
        <Scroll>
          <div id={`list${props.index}`} className="l-row" data-state={state}>
            <li className="c-grid__items--merit" data-state={state} data-dec={props.index % 3 == 0 ? 'dec': ''}>
              {state == "left" && (
                <Media
                  class="p-img__merit"
                  src={`${args.slug}/list${props.index}`}
                  alt="media"
                  state={state}
                />
              )}
              <div className="c-grid__items--merit__content">
                {args.slug !== 'service' &&
                  <Texts
                    slug={`${args.slug}/num${props.index}`}
                    class="c-text--main c-text--bold"
                    addText={"0" + (props.index + 1)}
                  />
                }
                <Space size={["16px 0 56px", "16px 0 48px"]}>
                  <div className={args.slug == 'service' ? 'p-title__wrap--en' : ''}>
                    <Texts
                      slug={`${args.slug}/title${props.index}`}
                      class="c-text--bold"
                      addText={args.addText[props.index][0]}
                    />
                  </div>
                </Space>
                <Texts
                  slug={`${args.slug}/body${props.index}`}
                  class="c-text--med"
                  addText={args.addText[props.index][1]}
                />
              </div>
              {state == "right" && (
                <Media
                  class="p-img__merit"
                  src={`${args.slug}/list${props.index}`}
                  alt="media"
                  state={state}
                />
              )}
            </li>
          </div>
        </Scroll>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i} />);
  }

  return (
    <>
      <ul className="c-grid__list--merit">{items}</ul>
    </>
  );
};
export default Merit;
